<template>
	<table class="table table-standard" :class="{ 'table-sm': smallTable }">
		<template v-if="isMobile === false">
			<thead>
				<tr>
                    <th class="border-none"></th>
					<th v-for="column in columns" :class="column.thClass || ''">{{ column.name }}</th>
					<th v-if="showDetail"></th>
				</tr>
			</thead>
			<tbody>
				<template v-for="(item, index) in items">
					<tr :class="{ 'opened-row': showDetail && openedIndex === index }">
                        <td class="border-none"></td>
						<td v-for="column in columns" @click="toggleOpened(index)">
							<slot :name="column.slug" :item="item">{{ item[column.slug] }}</slot>
						</td>
						<td @click="toggleOpened(index)" class="text-primary no-select border-none">
							<span v-if="showDetail && openedIndex !== index && condition(index)">
								<font-awesome-icon icon="info-circle" />
							</span>
							<span v-if="showDetail && openedIndex === index && condition(index)">
								<font-awesome-icon icon="times" />
							</span>
						</td>
					</tr>
					<tr class="detail-row" v-if="showDetail && openedIndex === index">
                        <td></td>
						<td :colspan="columns.length + (showDetail ? 1 : 0)">
							<slot name="detail" :item="item"></slot>
						</td>
					</tr>
				</template>
			</tbody>
		</template>
		<template v-if="isMobile === true">
			<template v-for="(item, index) in items">
				<tr :class="{ 'opened-row': showDetail && openedIndex === index }">
					<td @click="toggleOpened(index)">
						<div class="description-wrapper" v-for="column in columns">
							<label>{{ column.name }}</label>
							<div>
								<slot :name="column.slug" :item="item">{{ item[column.slug] }}</slot>
							</div>
						</div>
					</td>
					<td v-if="showDetail" @click="toggleOpened(index)" class="text-primary text-right no-select">
						<span v-if="openedIndex !== index && condition(index)">
							<font-awesome-icon icon="info-circle" />
						</span>
						<span v-if="openedIndex === index && condition(index)">
							<font-awesome-icon icon="times" />
						</span>
					</td>
				</tr>
				<tr class="detail-row" v-if="showDetail && openedIndex === index">
					<td :colspan="columns.length + (showDetail ? 1 : 0)">
						<slot name="detail" :item="item"></slot>
					</td>
				</tr>
			</template>
		</template>
	</table>
</template>

<script>
export default {
	name: "DataGrid",
	props: {
		columns: {
			type: Array,
			required: true,
		},
		items: {
			type: Array,
			required: true,
		},
		showDetail: {
			type: Boolean,
			required: false,
			default: true,
		},
		smallTable: {
			type: Boolean,
			required: false,
			default: false,
		},
		mobileTable: {
			type: Number,
			required: false,
			default: 992,
		},
		onDetailOpen: {
			type: Function,
			required: false,
			default: undefined,
		},
	},
	mounted() {
		this.setMobile();
		this.$nextTick(function() {
			window.addEventListener("resize", this.setMobile);
		});
	},
	destroyed() {
		window.removeEventListener("resize", this.setMobile);
	},
	methods: {
		setMobile() {
			const width = document.body.clientWidth || document.width;
			this.isMobile = width < this.mobileTable;
		},
		toggleOpened(index) {
            if (this.condition(index)) {
                const opened = this.openedIndex === index ? null : index;
                this.openedIndex = opened;

                if (this.onDetailOpen) {
                  this.onDetailOpen(this.items[index], index);
                }
            }
		},
        condition(index) {
            const route = this.$route.name;
            if (route === 'assets' && !this.items[index].code) {
                return false;
            } else if ((route === 'trades' || route === 'transactions') && (this.items[index].dealId === null || this.items[index].dealId === 0)) {
                return false;
            } else {
                return true;
            }
        },
	},
	data() {
		return {
			openedIndex: null,
			isMobile: false,
		};
	},
};
</script>

<style scoped>
    tr:not(.opened-row) .border-none {
        border-top: 2px solid #232323 !important;
    }

    .border-none {
        width: 35px;
    }
</style>
